import { ServiceCode } from '@common/enums';
import { never } from '@common/utils/never';
import type { IServiceDataItem } from './getServiceData';

export function getServiceDataForEpisodeNeurology(
    serviceCode: ServiceCode.Headache | ServiceCode.LumbarRadiculopathy
): Partial<IServiceDataItem> {
    switch (serviceCode) {
        case ServiceCode.Headache:
            return {
                costs: 'eigen risico belast',
                steps: [
                    'Verstuur een digitaal consultaanvraag naar Ksyos',
                    'Patiënt ontvangt een link voor de hoofdpijn-app via e-mail',
                    'Patiënt vult 30 dagen lang het digitale hoofdpijndagboek in',
                    'De neuroloog beoordeelt de gegevens en geeft behandeladvies',
                    'Je ontvangt de diagnose en behandeladvies via Edifact (in je HIS)',
                ],
                subTitle: (
                    <>
                        Voor patiënten met <strong>hoofdpijn- en migraineklachten</strong>
                    </>
                ),
                title: 'Hoofdpijn',
                waitingTime: 'Het schriftelijk consult volgt binnen 3 werkdagen na afronding van het hoofdpijndagboek',
            };
        case ServiceCode.LumbarRadiculopathy:
            return {
                costs: 'eigen risicovrij (m.u.v. DSW)',
                steps: [
                    'Vul de anamnese in',
                    'Verstuur de consultaanvraag',
                    'De fysiotherapeut maakt een afspraak met de patiënt',
                    'De fysiotherapeut doet onderzoek naar de klachten',
                    'De neuroloog beoordeelt de verzamelde gegevens',
                    'Je ontvangt het advies via ZorgMail in het HIS',
                ],
                title: 'Lage rugpijn met uitstraling',
                waitingTime: 'binnen 2 werkdagen',
            };
        default:
            never(serviceCode);
    }
}
